<template>
  <el-dialog
    :close-on-click-modal="true"
    :visible.sync="showDia1"
    title="下发预案短信"
  >
    <el-form ref="form" v-model="messForm" label-width="110px">
      <el-form-item v-if="type == 1" label="下发类型:" prop="type">
        <el-radio-group v-model="messForm.thing" @change="changeTier">
          <el-radio :label="0">消防演练</el-radio>
          <el-radio :label="1">发生火灾</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="一级分区:" prop="addr"  >
        <el-select
          v-model="messForm.drillInfo.drill_tower"
          :disabled="(type != 1 && type != 2)|| (messForm.thing===null)"
          filterable
          placeholder="请选择"
          @change="changetower"
        >
          <el-option
            v-for="(item, index) in units"
            :key="index"
            :label="item.tower"
            :value="item.tower"
            @change="changetower($event, index)"
          ></el-option>
           
        </el-select>
      </el-form-item>
      <el-form-item label="二级分区:" prop="ess" >
        <el-select
          v-model="messForm.drillInfo.drill_tier"
          :disabled="(type != 1 && type != 2)|| (messForm.thing===null)"
          filterable
          placeholder="请选择"
          @change="changeTier"
        >
          <el-option
            v-for="item in select2"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--{{drillList}}-->
      <el-form-item
        v-if="type == 1 || type == 2"
        :label="messForm.thing == 0 ? '演练选择' : '预案选择'"
        prop="uuid"
      >
        <el-select
          v-model="messForm.uuid"
          :disabled="(type != 1 && type != 2)|| (messForm.thing===null)"
          filterable
          placeholder="请选择"
          @change="changeDrill"
        >
          <el-option
            v-for="(item, index) in drillList"
            :key="index"
            :label="item.drillName"
            :value="item.drillUuid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下发人员:" prop="person">
        <div class="personGroup">
          <div v-for="(item, index) in roles" class="flex">
            <div class="groupLabel">{{ item.zuzhi_name + ":" }}</div>
            <div class="groupPersonCont">
              <div class="ml10 " style="float:left;margin-top:5px">
                {{ nameObj[item.zuzhi_xuhao] }}
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>

    <div class="center">
      <el-button v-loading="btnLoading" type="primary" @click="sendMessage()"
        >下发短信</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  props: ["cpNum", "type", "showDia"],
  data() {
    return {
      showDia1: false,
      roles: [],
      checkAll: false,
      btnLoading: false,
      types: null,
      people: [],
      nameObj: {},
      drillList: [], // 预案
      units: [],
      select2: [],
      messForm: {
        thing: null,
        uuid: "",
        drillInfo: {},
      },
      SendSMS: {
        drillName: "",
      },
    };
  },

  created() {
    this.init();
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      console.log(this.messForm.thing);
      var companyNum = this.$local.get("company").c_company_num;
      // if (this.messForm.thing==0||this.messForm.thing==3) {
      //   this.$post("/drill/companytowetinfo", {
      //     c_company_num:
      //       this.cpNum || this.$store.state.user.company.cCompanyNum,
      //   }).then((res) => {
      //     // console.log(res.data);
      //     this.units = res.data.list;
      //   });
      // } else {
        this.$get(`/drillplan/planJianzhu/planArea/${companyNum}`).then(
          (res) => {
            this.units = res.data;
          }
        );
      // }

      this.$post("/drill/grouplist").then((res) => {
        this.roles = res.data;
        console.log(res, 11111111);
      });
      this.clear(this.type);
    },
    // 演练记录
    getGroups() {
      log(this.messForm,'是不是0')
      if (this.messForm.thing==0||this.messForm.thing==3) {

        this.$post("/drill/drillinfo", { drill_uuid: this.types }).then(
          (res) => {
            this.messForm.drillInfo = res.data;
            var { personName: person } = res.data;
            log({ personName: person },7777777777)
            var obj = {
              1:person.zhihuiName,
						            8:person.lianluoName,
						            2:person.miehuoName,
						            3:person.shusanName,
						            4:person.jiuhuName,
						            5:person.jingjieName,
						            6:person.baozhangName,
						            7:person.jidongName
            };
            this.messForm.uuid = res.data.drill_uuid;
            this.nameObj = obj;
          }
        );
      } else {
        let drillUUid = this.messForm.uuid; //
        this.$get(
          `/planDrill/planDrill/selectPlanPersonByPlanId/${drillUUid}`
        ).then((res) => {
          console.log(res,33333333333);
          let form = res.data;
           var { personName: person } = res.data;
          let obj = {
            8: form.communicationLiaisonGroup, //通信联络组
					          7: form.evacuationEscapeGroup, // 疏散逃生组
					          3: form.evacuationGuidanceGroup, //  疏散引导组
					          1: form.fireCommandGroup, // 火场指挥组
					          2: form.fireFightActionGroup, // 灭火行动组
					          6: form.logisticsSupportGroup, // 后勤保障组
					          4: form.protectionRescueGroup, // 防护救护组
					          5: form.securityGroup, // 安全保卫组
          };
          this.nameObj = obj;
        });
      }
    },

    sendMessage() {
      console.log(this.messForm, "是不是2");
      var url;
      if (this.messForm.thing==0||this.messForm.thing==3) {
                url = "/drill/drillmessage";
      } else {
         this.messForm.drillUuid = this.messForm.uuid;
        url = "/planDrill/planDrill/planSendSMS";

      }
      this.btnLoading = true;

      this.$post(url, this.messForm)
        .then((res) => {
          this.$message({message: res.msg,type: "success", duration: 700,});
          this.btnLoading = false;
          if (!(this.type == 1)) {
            this.$parent.getList();
          }
          this.clear(this.type);
          this.showDia1 = false;
          this.people = [];
        })
        .catch((e) => {
          this.btnLoading = false;
        });
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.roles.length;
    },
    // 一级分区
    changetower(val, index) {
      this.messForm.drillInfo.drill_tier = "";
      this.messForm.uuid = "";
      this.units.map((item, index) => {
        if (item.tower === val) {
          log(item,111111111)
          this.select2 = item.tierList;
        }
      });
    },

    // 二级分区
    changeTier() {
      // this.messForm.uuid = "";
      log(this.messForm.thing,this.type,111111)
      var companyNum = this.$local.get("company").c_company_num;
      var drillTower = this.messForm.drillInfo.drill_tower;
      var drillTier = this.messForm.drillInfo.drill_tier;
      let drillStatus
      if ( this.messForm.thing==0||this.messForm.thing==3) {
       drillStatus = 0;
      }else{
       drillStatus = 1;
      }
     
      

      if (drillTower && drillTier && drillStatus !== undefined) {
        this.$post("planDrill/planDrill/selectPlanByArea", {
          drillTower,
          drillTier,
          companyNum: companyNum,
          drillStatus,
        }).then((res) => {
          this.drillList = res.data;
        });
      }
    },
    changeDrill(val) {
      this.types = this.messForm.uuid;
      this.getGroups();
    },

    getList() {
      // var base = this.url ? '/trxf/main/xf/danwei/xfdanweixinxi/listdata' : "/devicemanage/selectconpanybyme"
      if (this.url) {
        this.$post("/trxf/main/xf/danwei/xfdanweixinxi/listdatanew", {
          c_belong_profession: 174,
        }).then((res) => {
          this.list = res.list;
          this.checkCom();
        });
      } else {
        this.$post("/devicemanage/selectconpanybyme").then((res) => {
          this.list = res.data;
          this.checkCom();
          // this.$emit('getFirst',res.data[0].c_company_num)
        });
      }
    },
    clear(val) {
      this.messForm = {
        thing:null,
        uuid: "",
        drillInfo: {},
      };
      this.nameObj = {};
      if (val) {
        this.types = val;

        if (val == 2) {
          this.messForm.thing = 1;
          this.messForm.uuid = "";
        } else if (val == 1) {
          this.messForm.thing = null;
          this.messForm.uuid = "";
        } else {
          this.messForm.thing = 0;
          this.getGroups();
        }
      }
      this.btnLoading = false;
    },
  },
  watch: {
    type(val) {
      log(val);
    },
    showDia1(val) {
      if (val) this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.personGroup {
  padding: 10px;
  border: 1px solid #999;
  border-radius: 5px;
  height: 380px;
  overflow: auto;

  .groupLabel {
    width: 40%;
    text-align: right;
    font-weight: 900;
  }

  .groupPersonCont {
    width: 100%;
    line-height: 30px;
  }
}

::v-deep .el-dialog {
  z-index: 999 !important;
}
</style>
